import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Divider.module.css';

const Divider = ({ className }) => {
  return <div className={classNames(styles.divider, className)} />;
};

Divider.propTypes = {
  className: PropTypes.string,
};

Divider.defaultProps = {
  className: null,
};

export default Divider;
